import React from 'react'

export default function Limitations() {
  return (
    <div className='overflow-hidden pb-6 sm:py-10'>
      <div className='mx-auto max-w-7xl space-y-8 px-6 sm:px-6 lg:px-8 lg:py-0'>
        <div className='mx-auto text-base'>
          <p className='mt-2 text-center text-3xl font-thin leading-8 tracking-tighter text-gray-900 sm:tracking-tight md:text-3xl'>
            Limitations of Current Real Estate Tools
          </p>
        </div>
        <div className='mx-auto max-w-4xl text-center'>
          <p className='px-1 text-base font-light text-gray-500 sm:text-xl'>
            The demand on agents only keeps increasing but the REALTOR® toolbox
            hasn&apos;t kept up. Agents are waking up to the fact that they must
            use technology to boost their credibility, provide real value and
            build a trusted relationship that clients can rely on.
          </p>
        </div>
        <p className='pt-5 text-center text-xl font-light  sm:text-2xl'>
          Agents are often limited by...
        </p>
      </div>
      <dl className='mx-auto mt-10 max-w-6xl space-y-6 px-4 sm:mt-16 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-2 lg:gap-x-8 lg:px-8'>
        <div className='relative rounded-lg border-l-8 border-primary px-3 py-4 shadow'>
          <dt>
            <p className='ml-4 text-base font-light leading-6 sm:text-lg'>
              <span className='font-bold text-gray-900'>Location</span>
              {' '}
              <span className='text-gray-500'>
                and the challenge of expanding into new regions.
                {' '}
              </span>
            </p>
          </dt>
        </div>

        <div className='relative rounded-lg border-l-8 border-primary px-3 py-4 shadow'>
          <dt>
            <p className='ml-4 text-base font-light leading-6 sm:text-lg'>
              <span className='font-bold text-gray-900'>Experience</span>
              {' '}
              <span className='text-gray-500'>
                in any market, which takes years to develop.
              </span>
            </p>
          </dt>
        </div>

        <div className='relative rounded-lg border-l-8 border-primary px-3 py-4 shadow'>
          <dt>
            <p className='ml-4 text-base font-light leading-6 sm:text-lg'>
              <span className='font-bold text-gray-900'>Data access</span>
              {' '}
              <span className='text-gray-500'>
                and not having what they need to know about a property or region
                in one place.
              </span>
            </p>
          </dt>
        </div>

        <div className='relative rounded-lg border-l-8 border-primary px-3 py-4 shadow'>
          <dt>
            <p className='ml-4 text-base font-light leading-6 sm:text-lg'>
              <span className='font-bold text-gray-900'>Existing tools</span>
              {' '}
              <span className='text-gray-500'>
                and their sole focus of single property analysis.
              </span>
            </p>
          </dt>
        </div>
      </dl>

      {/* <div className='pb-3 mt-10 text-center sm:mt-16'>{renderTryButton()}</div> */}
    </div>
  )
}
